import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=8a1f993c&scoped=true"
import script from "./Media.vue?vue&type=script&lang=js"
export * from "./Media.vue?vue&type=script&lang=js"
import style0 from "./Media.vue?vue&type=style&index=0&id=8a1f993c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1f993c",
  null
  
)

export default component.exports